import { XIcon } from '@imedcl/design-system'
import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { FirstStep } from './FirstStep'
import { SecondStep } from './SecondStep'
import { ThirdStep } from './ThirdStep'

const HOST_BACKEDN_PFP =
  process.env.REACT_APP_PFP_BACKEND || window._env_.REACT_APP_PFP_BACKEND
const APIKEY_PRE =
  process.env.REACT_APP_APIKEY_PRE || window._env_.REACT_APP_APIKEY_PRE

export const ModalMFA = ({
  isOpen,
  onClose,
  billing,
  rut,
  setMfaVerifiedAt,
}) => {
  const [showModal, setShowModal] = useState(isOpen)
  const [step, setStep] = useState(1)
  const [loading, setLoading] = useState(false)
  const [loadingVerify, setLoadingVerify] = useState(false)
  const [error, setError] = useState('')
  const [trxId, setTrxId] = useState('')
  const [width, setWidth] = useState('608px')

  useEffect(() => {
    setShowModal(isOpen)
  }, [isOpen])

  const handleClose = useCallback(() => {
    setShowModal(false)
    setStep(1)
    setError('')
    setLoading(false)
    setTrxId('')
    setWidth('608px')
    setTimeout(() => {
      onClose()
    }, 300)
  }, [onClose])

  if (!isOpen) return null

  const onConfirmSend = async () => {
    setLoading(true)
    setError('')
    try {
      const { data } = await axios.post(
        `${HOST_BACKEDN_PFP}/v1/createMFA`,
        {
          rut,
          email: billing.email,
        },
        {
          headers: {
            apikey: APIKEY_PRE,
          },
        },
      )
      if (data.code.startsWith('E')) {
        setError(data.error?.message ?? 'Error en MFA')
        return
      }
      setTrxId(data.data.trxId)
      setStep(2)
    } catch (error) {
      setError(error.response?.data?.message ?? 'Error en MFA')
    } finally {
      setLoading(false)
    }
  }

  const onConfirmCode = async (code) => {
    setLoadingVerify(true)
    setError('')
    try {
      const { data } = await axios.post(
        `${HOST_BACKEDN_PFP}/v1/validateMFA`,
        {
          id: trxId,
          code,
        },
        {
          headers: {
            apikey: APIKEY_PRE,
          },
        },
      )
      if (data.code.startsWith('E')) {
        setError(data.error?.message ?? 'Error en MFA')
        return
      }
      setWidth('400px')
      setStep(3)
      const mfaVerifiedAt = new Date().toISOString()
      const mfaData = JSON.stringify({
        time: mfaVerifiedAt,
        rut: btoa(String(rut)),
      })
      localStorage.setItem('mfaVerifiedAt', mfaData)
      setMfaVerifiedAt(mfaVerifiedAt)
      setTimeout(() => {
        window.open(billing.Link_Factura, '_blank', 'noopener,noreferrer')
        handleClose()
      }, 3000)
    } catch (error) {
      setError(error.response?.data?.message ?? 'Error en MFA')
    } finally {
      setLoadingVerify(false)
    }
  }

  return (
    <div className='justify-center items-center flex overflow-hidden fixed inset-0 outline-none focus:outline-none bg-white/70 backdrop-blur-sm z-[9999999999999]'>
      <div className='my-6 mx-auto h-auto opacity-100'>
        <div
          style={{ width }}
          className={`translate duration-300 ${
            showModal ? 'translate-y-0' : 'translate-y-full'
          } ${
            showModal ? 'opacity-100' : 'opacity-0'
          } h-full p-10 bg-white rounded-lg shadow-lg border relative w-[608px]`}>
          {!loading && (
            <div
              className='absolute top-3 right-4 cursor-pointer'
              onClick={handleClose}>
              <XIcon />
            </div>
          )}
          <div className='mt-6'>
            {step === 1 && (
              <FirstStep
                onConfirmSend={onConfirmSend}
                loading={loading}
                handleClose={handleClose}
                email={billing.email}
                error={error}
              />
            )}
            {step === 2 && (
              <SecondStep
                onSubmit={onConfirmCode}
                error={error}
                loading={loading}
                loadingVerify={loadingVerify}
                onResendMessage={onConfirmSend}
              />
            )}
            {step === 3 && <ThirdStep />}
          </div>
        </div>
      </div>
    </div>
  )
}
